import styled from "styled-components";


export const StyledRegisterHeader = styled.header`

    width: 100%;
    max-width: 390px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 35px;

`